import React, { useEffect, useRef } from 'react';
import './ChatHistory.css';
import { AssistantMessage, AssistantThinkingMessage } from '../Message/AssistantMessage';
import UserMessage from '../Message/UserMessage';
import { useTranslation } from 'react-i18next';

function ChatHistory({ messages, onSuggestionClick, chatHistoryRef }) {
  const messagesEndRef = useRef(null);
  const { t, i18n } = useTranslation();

  // Index of the last assistant or assistant_thinking message (for "Latest response" heading)
  const lastAssistantIndex = (() => {
    let idx = -1;
    messages.forEach((m, i) => {
      if (m.type === 'assistant' || m.type === 'assistant_thinking') idx = i;
    });
    return idx;
  })();

  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages]);

  return (
      <section
          className="chat-history"
          ref={chatHistoryRef}
          aria-labelledby="chat-heading"
      >
        <h2 id="chat-heading" className="chat-history-heading">
          {t('chat.headings.conversation')}
        </h2>

        {messages.map((message, index) => {
          const isAssistant = message.type === 'assistant' || message.type === 'assistant_thinking';
          const isUser = message.type === 'user';
          const isSuggestion = message.type === 'suggestion';
          if (!isAssistant && !isUser && !isSuggestion) return null;

          const isLastAssistant = isAssistant && index === lastAssistantIndex;
          return (
              <React.Fragment key={message.id}>
                {isLastAssistant && (
                    <h3 id="latest-response" className="chat-history-subheading">
                      {t('chat.headings.latestResponse')}
                    </h3>
                )}
                {message.type === 'assistant' && (
                    <AssistantMessage text={message.text} direction={i18n.language === 'arabic' ? 'rtl' : 'ltr'} />
                )}
                {message.type === 'assistant_thinking' && (
                    <AssistantThinkingMessage text={message.text} direction={i18n.language === 'arabic' ? 'rtl' : 'ltr'} />
                )}
                {message.type === 'user' && (
                    <UserMessage text={message.text} direction={i18n.language === 'arabic' ? 'rtl' : 'ltr'} />
                )}
                {message.type === 'suggestion' && (
                    <div className="suggestion-message">
                      <button
                          className="suggestion-button"
                          onClick={() => onSuggestionClick(message.text)}
                          aria-label={`${t('chat.buttons.startChat')}: ${message.text}`}
                          dir={i18n.language === 'arabic' ? 'rtl' : 'ltr'}
                      >
                        {message.text}
                      </button>
                    </div>
                )}
              </React.Fragment>
          );
        })}
        <div ref={messagesEndRef} />
      </section>
  );
}

export default ChatHistory;
